module.exports = __webpack_public_path__ + "static/wireless-2b48caab7ed2961d806fc989a3136be1.png";